import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Button } from "react-bootstrap";
import moment from "moment";
import AllFeedbacks from "./AllFeedbacks";
import { fetchAllFeedbacksData } from "../../../redux/reducers/apiSlice";
import { selectAuth } from "../../auth/auth.selector";
import { BodyBuilder } from "../../../exports/Images";
// import Table from "../../components-bootstrap/Table2";
import PaginationModified from "../../../data/PaginationModified";
import PaginatedTable from "../../components-bootstrap/PaginatedTable";
// import ReactVortoxSpinner from "../../common-components/ReactVortoxSpinner";
import { convertStraight, formatDateTimezon } from "../../common-data/Converts";

const LastFeedback = ({
  filters,
  sendableQPs,
  queryParametersForAll,
  isFront,
}) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const { allFeedbacksData } = useSelector((state) => state.api);
  const initialFeedbacks = {
    pageNo: 0,
    allFeedbacksDatas: [],
    allFeedbackPaginationData: [],
  };
  const [allFeedbacks, setAllFeedbacks] = useState(initialFeedbacks);
  const [allFeedbackModal, setAllFeedbackModal] = useState(false);

  const latestFeedbackData =
    allFeedbacks.allFeedbacksDatas?.length > 0
      ? allFeedbacks.allFeedbacksDatas?.[0]
      : null;

  const formattedDate = (date) =>
    moment(parseInt(date) * 1000).tz("Asia/Kolkata").format("DD-MM-YYYY");

  function transformFeedbackData(apiResponse) {
    try {
      const res =
        apiResponse &&
        apiResponse.map((feedback) => ({
          activity_name: feedback.related_to,
          feedback: feedback.comment || "No Comments",
          rating: feedback.rating.toString(),
          user_name: feedback.name,
          date: new Date(feedback.feedback_date).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }),
        }));
      return res;
    } catch (error) {
      console.log(error);
      return [];
    }
  }

  useEffect(() => {
    if (sendableQPs) {
      dispatch(
        fetchAllFeedbacksData({
          pageNo: allFeedbacks.pageNo + 1,
          queryParameters: sendableQPs,
          token: decryptedText?.token,
        })
      );
    }
  }, [allFeedbacks.pageNo, sendableQPs]);

  useEffect(() => {
    if (allFeedbacksData?.status && allFeedbacksData?.data?.length > 0) {
      setAllFeedbacks((prevFeedbacks) => ({
        ...prevFeedbacks,
        allFeedbacksDatas: allFeedbacksData.data,
        allFeedbackPaginationData: allFeedbacksData?.pagination,
      }));
    } else {
      setAllFeedbacks(initialFeedbacks);
    }
  }, [allFeedbacksData, allFeedbacks.pageNo]);

  // useEffect(() => {
  //   if (sendableQPs) {
  //     setAllFeedbacks((prevData) => ({
  //       ...prevData,
  //       pageNo: 0,
  //       allFeedbackPaginationData: [],
  //     }));
  //   }
  // }, [sendableQPs]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  const feedbackCols = [
    {
      dataField: "user_name",
      text: "User name",
      formatter: (row) => {
        return (
          <div className="flex-k">
            <span className="fs-normal-k">{row}</span>
          </div>
        );
      },
    },
    {
      dataField: "activity_name",
      text: "Activity Name",
      formatter: (row) => {
        return (
          <div>
            <span className="badge-k fs-normal-k peach">{row}</span>
          </div>
        );
      },
    },
    {
      dataField: "rating",
      text: "Rating",
      formatter: (row) => {
        return (
          <div className="flex-k">
            <span className="fs-normal-k bold-text">{row}</span>
          </div>
        );
      },
    },
    {
      dataField: "feedback",
      text: "Feedback",
      formatter: (row) => {
        return (
          <div className="flex-k">
            <span className="fs-normal-k m-w-medium">{row}</span>
          </div>
        );
      },
    },
    {
      dataField: "date",
      text: "Date",
      formatter: (row) => {
        return (
          <div className="flex-k">
            <span className="fs-normal-k">{row}</span>
          </div>
        );
      },
    },
  ];

  const tbColumns = [
    {
      dataField: "trainer_name",
      text: "Trainer Name/Profile",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer">
          <img
            src={row?.trainer_profile || BodyBuilder}
            alt={row?.trainer_name || "N/A"}
            className="image"
          />
          <p
            className="name"
            style={{
              cursor: "pointer",
              minWidth: "200px",
              lineHeight: "normal", 
              margin: "0"
            }}
          >
            {row?.trainer_name || "N/A"}
            <br />
            <small style={{color: "gray"}}>{row?.gym_name || ""}</small>
          </p>
        </div>
      ),
    },
    {
      dataField: "name",
      text: "member name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info ">{row?.name || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "rating",
      text: "rating",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="info"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              columnGap: "10px",
            }}
          >
            {row?.rating || "0"}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-star-fill"
              viewBox="0 0 16 16"
            >
              <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
            </svg>
          </p>
        </div>
      ),
    },
    {
      dataField: "comment",
      text: "Comments",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info maxWidth150">{row?.comment || "No Comments"}</p>
        </div>
      ),
    },
    {
      dataField: "feedback_date",
      text: "feedback date",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="info ">
            {row?.feedback_date ? convertStraight(row.feedback_date) : "-"}
          </p>
        </div>
      ),
    },
    // {
    //   dataField: "gym_name",
    //   text: "Gym",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p className="info minWidth150">{row?.gym_name || "N/A"}</p>
    //     </div>
    //   ),
    // },
    // {
    //   dataField: "status",
    //   text: "Member Status",
    //   formatter: (cell, row) => (
    //     <div className="emeberDetailsRowContainer column">
    //       <p
    //         className="info"
    //         style={{
    //           background: row?.status === "active" ? "#B4E7B9" : "#F6EFEF",
    //           color: row?.status === "active" ? "#0A701B" : "#F13434",
    //           borderRadius: "8px",
    //           padding: "5px 10px",
    //         }}
    //       >
    //         {row?.status || "N/A"}
    //       </p>
    //     </div>
    //   ),
    // },
  ];


  return (
    <>
      <Modal
        isOpen={allFeedbackModal}
        onRequestClose={() => setAllFeedbackModal(false)}
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer lastFeedbackModalContainer bg-white rounded-5">
          <div className="modalHeadAndCloseContainer">
            <h2 className="titleHead">Feedback Received</h2>

            <div className="btnAndFilters">
              <button
                className="closeModalBtn"
                onClick={() => setAllFeedbackModal(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z" />
                </svg>
              </button>
            </div>
          </div>

          {isFront ? (
            <>
              <AllFeedbacks
                decryptedText={decryptedText}
                allFeedbacks={allFeedbacks}
                queryParametersForAll={queryParametersForAll}
                gymFeedbackFilter={filters?.selectedGym?.value}
              />
              <div className="paginationWithCards lastFlex">
                <PaginationModified
                  isPage={allFeedbacks.pageNo}
                  onChangePage={(value) =>
                    setAllFeedbacks((prevData) => ({
                      ...prevData,
                      pageNo: value,
                    }))
                  }
                  pagination={allFeedbacks.allFeedbackPaginationData}
                />
              </div>
            </>
          ) : (
            <div
              className="tabsPayoutsContainer allPtMemTabs"
              style={{ padding: "0", width: "100%" }}
            >
              <div className="allPtMembersTableContainer">
                <PaginatedTable
                  columnsValues={tbColumns}
                  dataValues={allFeedbacks?.allFeedbacksDatas}
                  paginationData={allFeedbacks.allFeedbackPaginationData}
                  isPage={allFeedbacks.pageNo}
                  setIsPage={(value) =>
                    setAllFeedbacks((prevData) => ({
                      ...prevData,
                      pageNo: value,
                    }))
                  }
                />
              </div>
            </div>
            // <div className="my-3">
            //   <Table
            //     columns={feedbackCols}
            //     data={
            //       transformFeedbackData(allFeedbacks?.allFeedbacksDatas) || []
            //     }
            //   />
            // </div>
          )}
        </div>
      </Modal>

      {latestFeedbackData ? (
        <div className="lastFeedbackCard">
          <div className="cardBlock firstBlock">
            <p className="trainerNmae">
              {latestFeedbackData?.trainer_name || "NA"}
            </p>
            <p className="trainerDesc">
              {latestFeedbackData?.description || "No Descritpion Available!"}
            </p>
          </div>
          <div className="cardBlock secondBlock">
            <div className="profileAndRating">
              <div className="picNameDate">
                <div className="pic">
                  <img
                    src={latestFeedbackData?.member_profile || BodyBuilder}
                    alt={latestFeedbackData?.name || "NA"}
                  />
                </div>
                <div className="nameDate">
                  <p className="name" style={{ textTransform: "capitalize" }}>
                    {latestFeedbackData?.name || "NA"}
                  </p>
                  <p className="date">
                    {latestFeedbackData?.date_added
                      ? formatDateTimezon(latestFeedbackData.date_added)
                      : "-"}
                  </p>
                </div>
              </div>
              <div className="rating">
                <p className="ratingNumber">
                  {latestFeedbackData?.rating || "-"}
                </p>
                <div className="stars">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-star-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                  </svg>
                </div>
              </div>
            </div>
            <div className="viewAllbutton">
              <Button
                variant="outline-danger"
                className="viewAll"
                onClick={() => setAllFeedbackModal(true)}
              >
                View All
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <span className="noDataFound">No Data Found!</span>
      )}
    </>
  );
};

export default LastFeedback;
